<template lang="pug">
.room-detail
  template(v-if='!$media.isMobile')
    h2 操作
    .ui.button.themed.labeled.icon(@click='goto_sign', :class='{disabled: !can_sign}', v-if='$permission.has("basic.create.contracts")')
      i.icon.file.text
      | 新签合同
    .ui.button.themed.labeled.icon(@click='goto_sign_preorder', :class='{disabled: !can_preorder}', v-if='$permission.has("basic.create.preorders")')
      i.icon.pin
      | 房屋预约

  h2 预定单 ({{preorders.length}})
  auto-table(
    unstackable,
    :defines='$defines.preorder',
    :data='sorted_preorders',
    :detail-view='true',
    :actions='get_preorder_actions',
    layout='detailed_table',
    @action:order='goto_preorder',
    @action:cancel='open_cancel_preorder_dialog')

  h2 全部合同
  auto-table(:defines='$defines.contract', unstackable, :data='contracts', :detail-view='true', actions='goto', @action:goto='goto_contract')

  h2 房间水电记录
  auto-table(:defines='$defines.charge', unstackable, :data='charges', :detail-view='true')

  dialog-cancel-preorder(:preorder='preorder_canceling', :room='room', :visible.sync='dialog_preorder_cancel', @exit='fetch_preorders()')
</template>

<script>
import { MakeForm, MakeFetcher } from '../../utils'
import { AutoTable } from '../auto'
import { PaymentMethodSelect } from '../basic'
import { DialogCancelPreorder } from '../forms'

export default {
  name: 'room-detail',
  props: ['no'],
  components: {
    AutoTable,
    PaymentMethodSelect,
    DialogCancelPreorder,
  },
  data() {
    return {
      charges: [],
      contracts: [],
      preorders: [],
      dialog_preorder_cancel: false,
      preorder_canceling: undefined,
    }
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    room_state() {
      return this.$store.getters.room_state(this.no)
    },
    can_sign() {
      return (this.room_state === 'avaliable'
        && this.avaliable_preorders.length === 0)
        || this.$permission.has('basic.create.contracts.always')
    },
    can_preorder() {
      return (this.room_state !== 'unavaliable'
        && this.avaliable_preorders.length === 0)
        || this.$permission.has('basic.create.preorders.always')
    },
    avaliable_preorders() {
      return this.preorders.filter(p => p.state === 'active')
    },
    sorted_preorders() {
      return this.preorders.sort((a, b) => this.$moment(b.time_created) - this.$moment(a.time_created))
    },
  },
  mounted() {
    this.fetch_contracts()
    this.fetch_preorders()
    this.fetch_charges()
  },
  methods: {
    beforeRouteEnter() {
      this.fetch_contracts()
      this.fetch_preorders()
      this.fetch_charges()
    },
    goto_contract(contract) {
      this.$router.push(`/room/${this.no}/contract/${contract._id}`)
    },
    goto_preorder(preorder) {
      this.$router.push(`/room/${this.room.no}/sign/by/${preorder._id}`)
    },
    goto_sign() {
      this.$router.push(`/room/${this.no}/sign`)
    },
    goto_sign_preorder() {
      this.$router.push(`/room/${this.no}/preorder`)
    },
    fetch_contracts: MakeFetcher({
      url() { return `rooms/${this.room._id}/contracts` },
      key: 'contracts',
    }),
    fetch_preorders: MakeFetcher({
      url() { return `rooms/${this.room._id}/preorders` },
      key: 'preorders',
    }),
    fetch_charges: MakeFetcher({
      url() { return `rooms/${this.room._id}/charges` },
      key: 'charges',
    }),
    cancel_preorder: MakeForm({
      type: 'put',
      url() { return `preorders/${this.preorder_canceling._id}/cancel` },
      confirm: '确定取消该预订单?',
      payload() {
        return this.preorder_canceling
      },
      $afterSuccess() {
        this.dialog_preorder_cancel = false
        this.fetch_preorders()
      },
    }),
    open_cancel_preorder_dialog(preorder) {
      this.preorder_canceling = preorder
      this.dialog_preorder_cancel = true
    },
    get_preorder_actions(preorder) {
      if (preorder && preorder.state === 'active')
        return ['order', 'cancel']
      return []
    },
  },
}
</script>



// WEBPACK FOOTER //
// RoomDetail.vue?021be09e